import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Type declarations are used at compile-time as 'headers' only (does NOT include the files)

import { ImageOrigin } from "abweb/service/image/api/ImageOrigin";
/**
 * TODO: move this to the server and generate so it can be marshalled from json
 */
export class ImageIdentifierInfo {
  constructor(namespace, id, type, scales = null, elementClasses = null, spanClasses = null) {
    _defineProperty(this, "_namespace", void 0);
    _defineProperty(this, "_id", void 0);
    _defineProperty(this, "_type", void 0);
    _defineProperty(this, "_scales", []);
    _defineProperty(this, "_elementClasses", null);
    _defineProperty(this, "_spanClasses", null);
    _defineProperty(this, "_origin", ImageOrigin.STANDARD);
    _defineProperty(this, "_locale", "EN");
    _defineProperty(this, "_extra", null);
    this._namespace = namespace;
    this._id = id;
    this._type = type;
    if (scales != null) {
      this._scales = scales;
    }
    this._elementClasses = elementClasses;
    this._spanClasses = spanClasses;
  }
  get namespace() {
    return this._namespace;
  }
  get id() {
    return this._id;
  }
  get type() {
    return this._type;
  }
  get spanClasses() {
    return this._spanClasses;
  }
  get elementClasses() {
    return this._elementClasses;
  }
  get scales() {
    return this._scales;
  }
  set origin(value) {
    this._origin = value;
  }
  get origin() {
    return this._origin;
  }
  get locale() {
    return this._locale;
  }
  set locale(value) {
    this._locale = value;
  }
  get extra() {
    return this._extra;
  }
  set extra(value) {
    this._extra = value;
  }

  /**
   * This is the full name and the unique identifier. Namespace:id
   */
  get fullId() {
    return `${this.namespace}:${this.id}`;
  }
}
//# sourceMappingURL=ImageIdentifierInfo.js.map
